// Loader.jsx
import React, { useEffect } from "react";
const Loader = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 700); // Adjusted loader duration to accommodate animations
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <p className="font-logo animate-pulse text-secondary-200 text-2xl mr-5">
        Casa Dipinta
      </p>
    </div>
  );
};

export default Loader;
